import React from "react";
import { Helmet } from "react-helmet-async";

export default function SEO({ title, description, path = "" }) {
  const fullTitle = title ? `${title} | CNGTPL Solar` : "CNGTPL Solar — Switch to Smart Solar Energy | Delhi";
  const desc = description || "India's trusted solar EPC company. Residential, Commercial & Industrial solar. Save up to 90% on bills. Govt subsidy and 25-year warranty.";
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
    </Helmet>
  );
}
